// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-attribution > ul > li {
  display: none;
}

.ol-control {
  background-color: transparent;
}

.ol-zoom {
  transform: scale(1.5);
  transform-origin: top left;
}

.custom-zoom-in,
.custom-zoom-out {
  width: 2.4rem !important;
  height: 2.4rem !important;
  font-size: 2rem !important;
  margin-top: 1.2rem !important;
  margin-left: 1rem !important;
  cursor: pointer !important;
  box-shadow: rgba(0, 0, 0, 0.36) 0px 0px 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/gis/src/components/BaseMap.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,qBAAA;EACA,0BAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,sDAAA;AACF","sourcesContent":[".ol-attribution > ul > li {\n  display: none;\n}\n\n.ol-control {\n  background-color: transparent;\n}\n\n.ol-zoom {\n  transform: scale(1.5);\n  transform-origin: top left;\n}\n\n.custom-zoom-in,\n.custom-zoom-out {\n  width: 2.4rem !important;\n  height: 2.4rem !important;\n  font-size: 2rem !important;\n  margin-top: 1.2rem !important;\n  margin-left: 1rem !important;\n  cursor: pointer !important;\n  box-shadow: rgba(0, 0, 0, 0.36) 0px 0px 4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
